import { Documento } from './../Models/Documento';
import { ClassicType } from './../../shared/models/ClassicType';
import { Categorie } from './../Models/Categorie';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiRestService } from './api-rest.service';
import { RitornoPaginazione } from 'src/app/shared/models/RitornoPaginazione';

@Injectable({
  providedIn: 'root'
})
export class DocumentiStoreService {
  constructor(private ApiRestService: ApiRestService) { }
  private EDITABLE = new BehaviorSubject<boolean>(false);
  private ADDABLE = new BehaviorSubject<boolean>(false);
  private CATEGORIE = new BehaviorSubject<Categorie[]>([]);
  private CATEGORIE_CERCATE = new BehaviorSubject<Categorie[]>([]);
  private TIPI = new BehaviorSubject<ClassicType[]>([]);
  private DOCUMENTI = new BehaviorSubject<RitornoPaginazione<Documento[]>>({ total: 0, data: [] });
  private DOCUMENTO = new BehaviorSubject<Documento>(null);
  private dataStore: {
    Editable: boolean,
    Addable: boolean,
    Categorie: Categorie[],
    CategorieCercate: Categorie[],
    Tipi: ClassicType[],
    Documenti: RitornoPaginazione<Documento[]>,
    Documento: Documento
  } = {
      Editable: false,
      Addable: false,
      Categorie: [],
      CategorieCercate: [],
      Tipi: [],
      Documenti: {total: 0, data:[]},
      Documento: null
    }
  readonly $editable = this.EDITABLE.asObservable();
  readonly $addable = this.ADDABLE.asObservable();
  readonly $tipi = this.TIPI.asObservable();
  readonly $categorieCercate = this.CATEGORIE_CERCATE.asObservable();
  readonly $categorie = this.CATEGORIE.asObservable();
  readonly $documenti = this.DOCUMENTI.asObservable();
  readonly $documento = this.DOCUMENTO.asObservable();
  refreshEditable = () => this.EDITABLE.next(Object.assign({}, this.dataStore).Editable);
  refreshAddable = () => this.ADDABLE.next(Object.assign({}, this.dataStore).Addable);
  refreshCategorie = () => this.CATEGORIE.next(Object.assign({}, this.dataStore).Categorie);
  refreshCategorieCercate = () => this.CATEGORIE_CERCATE.next(Object.assign({}, this.dataStore).CategorieCercate);
  refreshTipi = () => this.TIPI.next(Object.assign({}, this.dataStore).Tipi);
  refreshDocumenti = () => this.DOCUMENTI.next(Object.assign({}, this.dataStore).Documenti);
  refreshDocumento = () => this.DOCUMENTO.next(Object.assign({}, this.dataStore).Documento);
  getTipi() {
    this.ApiRestService.getTipiDocumenti().subscribe(data => {
      this.dataStore.Tipi = data;
      this.refreshTipi();
    })
  }
  getDocumenti(value) {
    this.ApiRestService.getListaDocumenti(value).subscribe(data => {
      this.dataStore.Documenti = data;
      this.refreshDocumenti();
    })
  }
  getCategorie(value?) {
    if (value) {
      this.ApiRestService.searchCategorieDocumento(value).subscribe(data => {
        this.dataStore.CategorieCercate = data;
        this.refreshCategorieCercate();
      })
    }
    else {
      this.ApiRestService.getListCategorieDocumento().subscribe(data => {
        this.dataStore.Categorie = data;
        this.refreshCategorie();
      })
    }
  }
  updateDocumentoSelezionato(value: Documento) {
    this.dataStore.Documento = value;
    this.refreshDocumento();
  }
  updateAddable(value: boolean) {
    this.dataStore.Addable = value;
    this.refreshAddable();
  }
  updateEditable(value: boolean) {
    this.dataStore.Editable = value;
    this.refreshEditable();
  }

}
